import { AnimatedComponent } from "@/components/common";
import { TableTitles } from "@/constants";
import { useGetMeditatorAttendance } from "@/hooks/query-hooks/useCheckInCheckOut";
import { useGetMeditationRetreatDetail } from "@/hooks/query-hooks/useMeditationRetreats";
import { Breadcrumb, Divider } from "antd";
import { useState } from "react";
import { Link, useParams } from "react-router";
import { MeditationRetreatsTable } from "../MeditationRetreats";
import { AttendanceTable } from "./AttendanceTable";

export function AttendanceList() {
	const retreatId = useParams().id;

	const [page, setPage] = useState(1);

	const { data: meditationRetreat, isLoading: isRetreatLoading } =
		useGetMeditationRetreatDetail(retreatId!);

	const { data: attendance, isLoading: isAttendanceLoading } =
		useGetMeditatorAttendance({
			retreatId: Number(retreatId),
			page,
		});

	const dataSource = attendance?.content;

	const renderRetreatColumnsKey = [
		TableTitles.retreat_start_month,
		TableTitles.retreat_name,
		TableTitles.retreat_level,
		TableTitles.retreat_start_date,
		TableTitles.retreat_end_date,
		TableTitles.total_registrants,
		TableTitles.retreat_status,
	];

	return (
		<AnimatedComponent>
			<Breadcrumb
				separator="/"
				items={[
					{
						title: (
							<Link
								to={"/attendance/meditation-retreats"}
								className="text-base font-semibold hover:!bg-transparent"
							>
								တရားစခန်းများ
							</Link>
						),
						key: "retreats",
					},
					{
						title: (
							<p className="text-base font-semibold">
								{meditationRetreat?.title || "Loading..."}
							</p>
						),
						key: "retreat-detail",
					},
				]}
			/>
			<Divider />
			<MeditationRetreatsTable
				dataSource={[meditationRetreat!]}
				renderColumnKeys={renderRetreatColumnsKey}
				loading={isRetreatLoading}
				pagination={false}
				hasFilter={false}
				rowKey={(record) => record.id}
			/>
			<Divider />
			<AttendanceTable
				dataSource={dataSource}
				currentPage={page}
				pagination={{
					current: page,
					onChange: (page) => setPage(page),
					total: attendance?.totalElements,
				}}
				loading={isAttendanceLoading}
			/>
		</AnimatedComponent>
	);
}
